import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { useAuthStore } from "@roman/shared/store/auth.store";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CodeInputPage } from "./CodeInputPage";
import { NumberInputPage } from "./NumberInputPage";

enum PageStep {
  numberInput = "NumberInput",
  codeInput = "CodeInput",
  success = "Success",
}

export const SMSVerificationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [step, setStep] = useState<PageStep>(PageStep.numberInput);
  const [phoneNumber, setPhoneNumber] = useState("");
  const { refetch } = useAuthStore();

  // Todo: Verify if the phone number is already registered. If so, we shouldn't have access to this page.

  const path = location.state?.from ?? "/";
  const onSuccess = () => {
    setStep(PageStep.success);
    refetch();
  };

  return (
    <div
      className="flex flex-col items-center min-h-[calc(100vh-72px)]"
      style={{
        backgroundImage: `url('/assets/bg.svg')`,
        backgroundRepeat: "repeat",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div className="w-full min-h-[calc(100vh-72px)] max-w-3xl p-8 bg-white">
        {step === PageStep.numberInput && (
          <NumberInputPage
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            onNextStep={() => setStep(PageStep.codeInput)}
          />
        )}
        {step === PageStep.codeInput && <CodeInputPage phoneNumber={phoneNumber} onNextStep={onSuccess} />}
        {step === PageStep.success && (
          <div className="flex flex-col items-center justify-center">
            <h1 className="text-2xl mb-5 font-semibold text-center text-black">電話番号の登録が完了しました!</h1>
            <p className="text-center text-dark-gray">引き続きサンバを楽しんでください。</p>
            <PrimaryButton className="w-[450px] mt-10" content="次へ" onClick={() => navigate(path)} />
          </div>
        )}
      </div>
    </div>
  );
};
